import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

interface SplitCompareProps {
  leftText: string;
  leftDesc?: string;
  rightText: string;
  rightDesc?: string;
  style: {
    leftColor: string;
    rightColor: string;
    entrance: "slideIn";
  };
}

const SplitCompare: React.FC<SplitCompareProps> = ({
  leftText,
  leftDesc,
  rightText,
  rightDesc,
  style,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const leftProgress = spring({
    frame,
    fps,
    config: { damping: 14, mass: 0.7, stiffness: 100 },
    durationInFrames: 30,
  });

  const rightProgress = spring({
    frame: Math.max(0, frame - 10),
    fps,
    config: { damping: 14, mass: 0.7, stiffness: 100 },
    durationInFrames: 30,
  });

  const dividerProgress = spring({
    frame: Math.max(0, frame - 5),
    fps,
    config: { damping: 20 },
    durationInFrames: 20,
  });

  const leftX = interpolate(leftProgress, [0, 1], [-200, 0]);
  const leftOpacity = interpolate(leftProgress, [0, 0.2, 1], [0, 1, 1]);

  const rightX = interpolate(rightProgress, [0, 1], [200, 0]);
  const rightOpacity = interpolate(rightProgress, [0, 0.2, 1], [0, 1, 1]);

  const dividerHeight = interpolate(dividerProgress, [0, 1], [0, 300]);
  const dividerOpacity = interpolate(dividerProgress, [0, 0.3, 1], [0, 0.5, 0.8]);

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0a0a0a",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* 左栏 */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0 40px",
          transform: `translateX(${leftX}px)`,
          opacity: leftOpacity,
        }}
      >
        <div
          style={{
            fontSize: 64,
            fontWeight: 900,
            color: style.leftColor,
            fontFamily: "sans-serif",
            textTransform: "uppercase",
            letterSpacing: "2px",
            WebkitTextStroke: "8px black",
          }}
        >
          {leftText}
        </div>
        {leftDesc && (
          <div
            style={{
              fontSize: 28,
              fontWeight: 500,
              color: "rgba(0,245,255,0.85)",
              fontFamily: "sans-serif",
              textAlign: "center",
              marginTop: 20,
              lineHeight: 1.6,
              whiteSpace: "pre-line",
            }}
          >
            {leftDesc}
          </div>
        )}
      </div>

      {/* 中间分割线 */}
      <div
        style={{
          width: 4,
          height: dividerHeight,
          background: `linear-gradient(to bottom, transparent, ${style.rightColor}, transparent)`,
          borderRadius: 2,
          opacity: dividerOpacity,
        }}
      />

      {/* 右栏 */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0 40px",
          transform: `translateX(${rightX}px)`,
          opacity: rightOpacity,
        }}
      >
        <div
          style={{
            fontSize: 64,
            fontWeight: 900,
            color: style.rightColor,
            fontFamily: "sans-serif",
            textTransform: "uppercase",
            letterSpacing: "2px",
            WebkitTextStroke: "8px black",
          }}
        >
          {rightText}
        </div>
        {rightDesc && (
          <div
            style={{
              fontSize: 28,
              fontWeight: 500,
              color: "rgba(0,245,255,0.85)",
              fontFamily: "sans-serif",
              textAlign: "center",
              marginTop: 20,
              lineHeight: 1.6,
              whiteSpace: "pre-line",
            }}
          >
            {rightDesc}
          </div>
        )}
      </div>
    </AbsoluteFill>
  );
};

export default SplitCompare;
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
